var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class PriceListItemResponseDto {
    id;
    posNumber;
    officialName;
    customName;
    priceNet;
    priceGross;
    /** The transcribed figure, or `null` where nothing has been transcribed. */
    copayment;
    /**
     * The contract declares this position free of Zuzahlung (#1495). Distinct
     * from `copayment: 0` and from `copayment: null` — the three states mean
     * "lawfully nothing owed", "arithmetically nothing owed" and "not
     * determinable", and a reader that collapses them misreports the first.
     */
    copaymentExempt;
    taxType;
    taxRate;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListItemResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListItemResponseDto.prototype, "posNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListItemResponseDto.prototype, "officialName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListItemResponseDto.prototype, "customName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PriceListItemResponseDto.prototype, "priceNet", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PriceListItemResponseDto.prototype, "priceGross", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PriceListItemResponseDto.prototype, "copayment", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PriceListItemResponseDto.prototype, "copaymentExempt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PriceListItemResponseDto.prototype, "taxType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PriceListItemResponseDto.prototype, "taxRate", void 0);
//# sourceMappingURL=price-list-item.response.dto.js.map